module.exports = __webpack_public_path__ + "static/favicon-8a82ff1cec58056929a7fde284005d70.ico";